import { Executive } from '../types/executive.ts';

// Sample executive data
const executives: Executive[] = [
  {
    id: '1',
    name: 'Elara', // Vega
    title: 'Chief Executive Officer',
    role: 'Chief Executive Officer',
    avatarType: 'ai',
    section: 'capital',
    specialty: 'Strategic Vision & Leadership',
    status: 'available',
    rating: 4.9,
    completedTasks: 187,
    bio: 'Expert in strategic planning and business transformation with over 15 years of experience.',
    skills: ['Strategic Planning', 'Business Transformation', 'Leadership']
  },
  {
    id: '2',
    name: 'Michael', //  Chen
    title: 'Chief Financial Officer',
    role: 'Chief Financial Officer',
    avatarType: 'finance',
    section: 'capital',
    specialty: 'Financial Strategy & Investment',
    status: 'busy',
    rating: 4.8,
    completedTasks: 64,
    bio: 'Specializes in finance, investment strategy and portfolio management across diverse markets.',
    skills: ['Investment Analysis', 'Portfolio Management', 'Risk Assessment']
  },
  {
    id: '3',
    name: 'Sophia', //  Rodriguez
    title: 'Chief Marketing Officer',
    role: 'Chief Marketing Officer',
    avatarType: 'growth',
    section: 'capital',
    specialty: 'Market Expansion',
    status: 'available',
    rating: 4.7,
    completedTasks: 52,
    bio: 'Focused on identifying and executing growth opportunities in emerging markets.',
    skills: ['Market Analysis', 'Growth Hacking', 'Business Development']
  },
  {
    id: '4',
    name: 'David', // Park
    title: 'Chief Strategy Officer',
    role: 'Chief Strategy Officer',
    avatarType: 'finance',
    section: 'capital',
    specialty: 'Financial Modeling',
    status: 'available',
    rating: 4.6,
    completedTasks: 41,
    bio: 'Expert in financial modeling and analysis with a background in investment banking.',
    skills: ['Financial Modeling', 'Valuation', 'Data Analysis']
  },
  {
    id: '5',
    name: 'Zara', //  Thompson
    title: 'Chief Technology Officer',
    role: 'Chief Technology Officer',
    avatarType: 'code',
    section: 'operations',
    specialty: 'Technology Strategy',
    status: 'available',
    rating: 4.9,
    completedTasks: 93,
    bio: 'Technology leader with expertise in scaling engineering teams and implementing cutting-edge solutions.',
    skills: ['Technology Strategy', 'Engineering Leadership', 'System Architecture']
  },
  {
    id: '6',
    name: 'Julian', // Wright
    title: 'Chief Product Officer',
    role: 'Chief Product Officer',
    avatarType: 'engineering',
    section: 'operations',
    specialty: 'Product Development',
    status: 'busy',
    rating: 4.8,
    completedTasks: 78,
    bio: 'Specializes in product development and innovation with a focus on user experience and market fit.',
    skills: ['Product Management', 'User Experience', 'Market Research']
  },
  {
    id: '7',
    name: 'James', // Wilson
    title: 'Chief Operations Officer',
    role: 'Chief Operations Officer',
    avatarType: 'analytics',
    section: 'operations',
    specialty: 'Operational Excellence',
    status: 'available',
    rating: 4.7,
    completedTasks: 56,
    bio: 'Expert in operational excellence and process optimization with a focus on efficiency and scalability.',
    skills: ['Process Optimization', 'Operational Efficiency', 'Change Management']
  },
  {
    id: '8',
    name: 'Leo', // Blackwell
    title: 'Chief Risk Officer',
    role: 'Chief Risk Officer',
    avatarType: 'strategy',
    section: 'operations',
    specialty: 'Risk Management',
    status: 'available',
    rating: 4.6,
    completedTasks: 49,
    bio: 'Expert in risk management and compliance with a focus on mitigating potential threats and ensuring regulatory compliance.',
    skills: ['Risk Assessment', 'Compliance', 'Regulatory Affairs']
  }
];

/**
 * Get all executives
 * @returns Array of executives
 */
export const getAllExecutives = (): Executive[] => {
  return executives;
};

/**
 * Get executives by section
 * @param section Section to filter by
 * @returns Filtered array of executives
 */
export const getExecutivesBySection = (section: string): Executive[] => {
  return executives.filter(exec => exec.section === section);
};

/**
 * Get executive by ID
 * @param id Executive ID
 * @returns Executive or undefined if not found
 */
export const getExecutiveById = (id: string): Executive | undefined => {
  return executives.find(exec => exec.id === id);
}; 